<template>
  <Breadcrumbs
      title="Dealer Groups"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealer Groups', path: '/dealer-groups' },
      { label: 'Edit Dealer Group', path: `/edit-dealer-group?dealerGroupId=${dealerGroupId}` },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editDealerGroupForm :dealerGroupId="dealerGroupId" />
    </div>
  </div>
</template>

<script>

import editDealerGroupForm from "@/pages/master_data/dealer_groups/editDealerGroupForm.vue";

export default {
  components: {
    editDealerGroupForm
  },
  computed: {
    dealerGroupId() {
      return this.$route.query.dealerGroupId;
    }
  }
}
</script>